import { Link as GLinkBase } from 'gatsby'
import styled, { css } from 'styled-components'

const commonLinkStyle = css<{
    $type: 'small' | 'medium'
    $underline: boolean
}>`
    text-decoration: ${(props) => (props.$underline ? 'underline' : 'none')};
    color: ${(props) => props.theme.color.p500};
    ${(props) => (props.$type === 'small' ? props.theme.typo.displayXXS : props.theme.typo.displayXS)};
    ${(props) => props.theme.fontWeight.medium};
`

export const A = styled.a<{
    $type: 'small' | 'medium'
    $underline: boolean
}>`
    ${commonLinkStyle}
`

export const GLink = styled(GLinkBase)<{
    $type: 'small' | 'medium'
    $underline: boolean
}>`
    ${commonLinkStyle}
`
